<template>
  <IndicatorCard
    :loading="loading"
    :has-data="services.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhum serviço encontrado')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >
    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

      <div class="wrapper">
        <v-simple-table
          v-if="services.length"
          class="main-table"
          height="500"
          fixed-header
        >
          <thead>
            <tr>
              <th class="pa-3 text-center" style="min-width: 140px">
                Responsável
              </th>
              <th
                class="pa-3 text-center"
                style="min-width: 200px; text-transform: capitalize"
                v-for="header in services[0].weeks"
                :key="header.week"
              >
                {{ header.week }}
              </th>
              <th class="pa-3 text-center" style="min-width: 160px">
                Total (período)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="service in services" :key="service.responsible">
              <td style="min-width: 140px" class="pb-2 text-center">
                <span class="font-weight-bold">{{ service.responsible }}</span>
              </td>
              <td
                class="text-center"
                style="min-width: 200px; font-weight: normal !important"
                v-for="week in service.weeks"
                :key="week.week"
              >
                <p>
                  Solicitadas:
                  <span class="font-weight-bold">{{ week.requested }}</span>
                </p>

                <p>
                  Concluídas:
                  <span class="font-weight-bold">{{ week.completed }}</span>
                </p>
              </td>
              <td
                class="text-center"
                style="min-width: 160px; font-weight: normal !important"
              >
                <p>
                  Solicitadas:
                  <span class="font-weight-bold">{{ service.totalRequested }}</span>
                </p>
                <p>
                  Concluídas:
                  <span class="font-weight-bold">{{ service.totalCompleted }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>

    <template #review>
      <v-row class="ma-0">
        <v-col cols="12" v-if="isResult && review">
          <strong>{{ $t('Análise crítica') }}</strong>
          <p v-html="review"></p>
        </v-col>
        <v-col cols="12" v-else-if="!isResult">
          <tiptap-vuetify
            v-model="filter.review"
            :extensions="extensions"
            :label="$t('Análise crítica')"
            :placeholder="
              $t('Digite sua análise crítica para o indicador abaixo')
            "
            :card-props="{ flat: true, outlined: true, rounded: true }"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
          ></tiptap-vuetify>
        </v-col>
      </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import {
  getIndicatorById,
  getIndicatorExportName,
} from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import moment from 'moment'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  name: 'ResponsibleServicesByWeek',

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  data() {
    return {
      excelLoading: false,
      services: [],
      loading: true,
      apiService: new ApiService(),
      page: 1,
      pageSize: 10,
      headers: [{ text: 'Responsável', value: 'responsible', align: 'center' }],
      headerProps: {
        sortByText: 'Ordenar por',
      },

      chartKey: false,
      startDate: '',
      endDate: '',
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {},
      showChart: true,
      haveResponse: false,
      totalPages: 1,
      servicesChartData: {},
      labels: [],
    }
  },

  computed: {
    indicator() {
      return getIndicatorById('responsible_services_by_week') || {}
    },
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp && this.filterProp.startDate) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  methods: {
    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${getIndicatorExportName(
        'responsible_services_by_week',
        this.institution
      )}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, { ...this.filter, pageSize: 999999 })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: getIndicatorById('responsible_services_by_week').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      if (this.filterProp) this.filterProp.data = null
      this.list()
    },

    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
          const response = JSON.parse(this.filterProp.data)
          this.services = response.content || []
          if (this.services.length && this.services[0].weeks) {
            this.headers = [
              { text: 'Responsável', value: 'responsible', align: 'center' },
              ...this.services[0].weeks.map((x) => {
                return { text: x.week, value: 'weekvalue', align: 'center' }
              }),
            ]
          }
          return
        }

        if (!this.isResult) this.setDates()
        this.filter.page = this.page
        this.filter.pageSize = this.pageSize

        const response = await this.apiService.post(
          this.apiEndpointOverride || 'reports/responsibleServicesByWeek',
          this.filter
        )
        this.services = response.content || []
        if (this.services.length && this.services[0].weeks) {
          this.headers = [
            { text: 'Responsável', value: 'responsible', align: 'center' },
            ...this.services[0].weeks.map((x) => {
              return { text: x.week, value: 'weekvalue', align: 'center' }
            }),
          ]
        }
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.services = []
      } finally {
        this.loading = false
      }
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>

<style scoped>
.main-table {
  font-size: 14px;
  overflow-x: auto;
}

.wrapper {
  overflow-x: auto;
}
</style>
